<template>
  <section v-if="error">
  <br/>
  <p class="error">{{ error }}</p>
  </section>
  <section class="page-container grid-container" v-if="!error && loaded">
    <div class="grid-container wizard">
      
        <section>    
        <div class="grid-x grid-margin-x">
            <div class="cell small-12">
                <a @click="router.back()">← Back</a>
            </div>
        </div>
        </section>

        <section>

            <div class="grid-x grid-margin-x">
                <div class="cell small-12">
                    <h1>Provide Your Company Data</h1>
                    <p>In order to set up your payroll, we need to collect some information about your company and require you to conduct some tasks. </p>
                    <p>Please complete each of the taks below.</p>
                </div>
                <div class="cell small-12">
                    <Panel
                        v-for="(panel, idx) in panelCards"
                        :key="idx"
                        :title="panel.title"
                        :description="panel.subtitle"
                        :status="splitByCapitals(panel.status)"
                        :icon="panel.icon"
                        :route="panel.route"
                    />
                </div>
            </div>
            <br/>
            <button class="btn btn-secondary" @click="router.push({ name: 'Home' })">Return to Home</button>
        </section>

        


</div>


  </section>
</template>

<script setup>
import { onMounted, ref, computed } from 'vue'
import { useRouter } from 'vue-router'
import { splitByCapitals } from '@/helpers/strings';
import Panel from '@/components/controls/Panel.vue'
import { icons } from '@/assets/icons'
import { buildCards } from '@/helpers/panelcard/cardfactory'


const router  = useRouter()
const loaded = ref(false);
const taskId = router.currentRoute.value.params.taskId;
const error = ref(null);
const icon = icons.cog

import { getDataCollectionTasks } from '@/services/implementationmanagement.api';

const errorString = 'An error has occurred. Please contact your Qtac account manager.';

import { useProjectStore } from '@/stores/project'
const project = useProjectStore()


const panelCards = ref([])

onMounted(async () => {

    try {

        let dataCollectionTasks = await getDataCollectionTasks(project.projectId);

        if (dataCollectionTasks && dataCollectionTasks.status !== 204) {
            dataCollectionTasks = dataCollectionTasks.data;

            panelCards.value = await buildCards(dataCollectionTasks, true);
        }

    } catch (err) {
        error.value = errorString;
        console.error(err);
    }




loaded.value = true;
})




</script>

